
export enum QuestionType {
    Binary = 1,
    Text = 2,
    Numeric = 3,
    Location = 4,
    Slider = 5,
    List = 6,
    MultiList = 7,
    Phone = 8,
    Calculated = 9,
    Currency = 10,
    Composite = 11,
    Date = 12,
    DateTime = 13,
    TextArea = 14,
    Result = 15,
    GUID = 16,
    Address = 17,
    Signature = 19,
    //MultipleSignature = 20,
    Annex = 21,
    CalculatedDate = 22,
    DateDifference = 23,
    Entity = 24,
    Delimitation = 25
}

export enum FormType{
    client="CLIENT_INFO",
    regular="REGULAR",
    free="FREE",
}

export interface User{
    id?:string;
    username:string;
    email?:string;
}

export interface Person{
    id?:string;
    nombre:string;
    apellido?:string;
    telefono:string;
    email:string;
    cedula:string;
}

export interface Producer{
    id?:string;
    persona:Person;
}

export interface AdditionalInfoResponse{
    valor:any;
}

export interface AdditionalInfoQuestion{
    pk:number;
    descripcion:string;
    tipo:QuestionType;
    metadato:any;
    orden:number;
}

export interface EntityAdditionalInfoItem{
    pregunta:AdditionalInfoQuestion;
    respuesta_tipo:AdditionalInfoResponse;
}

export interface Entity{
    id?:string;
    nombre:string;
    etiquetas?:string[];
    productor:Producer;
    geolocalizacion?:string | any;
    identificacion:string;
    informacionGeneral:EntityAdditionalInfoItem[];
}

export interface Question{
    id:string | number;
    descripcion:string;
    tipo:any;
    metadata:any;
    orden:number;
}

export interface Chapter{
    id:string;
    nombre:string;
    metadata:any;
    preguntaSet:Question[];
}

export interface Form {
    id:string;
    descripcion:string;
    metadata:any;
    tipo:FormType;
    capituloSet:Chapter[];
}

export interface Professional {
    id?: string;
    usuario?: User;
}
